import { render, staticRenderFns } from "./CenterAdd.vue?vue&type=template&id=6cee839d&"
import script from "./CenterAdd.vue?vue&type=script&lang=ts&"
export * from "./CenterAdd.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports